// src/pages/SetNickname.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./SetNickname.scss";

const SetNickname = () => {
  const [nickname, setNickname] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  // 토큰 유무 확인
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
    }
  }, [navigate]);

  const handleSubmit = async () => {
    console.log("[SetNickname] Handle submit called. Nickname:", nickname);

    if (!nickname.trim()) {
      setMessage("닉네임을 입력해주세요.");
      return;
    }

    const token = localStorage.getItem("token");
    console.log("[SetNickname] Token:", token);

    const endpoint = `${process.env.REACT_APP_API_URL}/auth/nickname`;
    console.log("[SetNickname] Endpoint:", endpoint);

    try {
      const response = await axios.post(
        endpoint,
        { nickname },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      console.log("[SetNickname] Response:", response.data);
      if (response.data.message === "닉네임 등록 완료") {
        navigate("/chat");
      } else {
        setMessage(response.data.message || "닉네임 등록 실패");
      }
    } catch (err) {
      console.error("[SetNickname] Error:", err);
      const errMsg = err.response?.data?.message;
      setMessage(errMsg || "닉네임 등록 실패");
    }
  };

  return (
    <div className="nickname-container">
      <div className="nickname-form">
        <h2>닉네임 설정</h2>
        <p>채팅을 위해 사용할 닉네임을 입력해주세요.</p>
        <input
          type="text"
          placeholder="닉네임 입력"
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
        />
        {message && <p className="error">{message}</p>}
        <button onClick={handleSubmit}>저장</button>
      </div>
    </div>
  );
};

export default SetNickname;
